import React from "react";
import { useAppwrite } from "../hooks/useAppwrite";
import { Button } from "react-bootstrap";

function UserMenu(): JSX.Element {

    const appwriteCtx = useAppwrite();

    return (
        <div className="d-flex text-light">
            <p>{appwriteCtx.user?.name}</p>
            <Button variant="secondary" onClick={() => appwriteCtx.logout()}>Logout</Button>
        </div>
    );


}
export default UserMenu;